import { render } from "./WalletTransactionTable.vue?vue&type=template&id=776987bc&scoped=true"
import script from "./WalletTransactionTable.vue?vue&type=script&lang=js"
export * from "./WalletTransactionTable.vue?vue&type=script&lang=js"

import "./WalletTransactionTable.vue?vue&type=style&index=0&id=776987bc&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776987bc"]])

export default __exports__